import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSellers, setFiltroSeller, changeSellerStatus } from '../../actions/sellersActions';
import { setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import { limpiarFiltros } from '../../actions/generalActios';
import SellerListItem from './SellerListItem';
import BigSpinner from '../General/BigSpinner';
import BtnToggleFilter from '../General/Filter/BtnToggleFilter';
import FiltroSellers from './FiltroSellers';
import ReactPaginate from 'react-paginate';
import { withNavigation } from '../General/withNavigation';


class ListSellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilter: this.props.filtro?.showFilter ?? false
        };
        this.INITIAL_REQUEST = {
            razonSocial: "",
            cantidadPagina: 10,
            numeroPagina: 1
        };
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        if (this.props.sellers?.paginateSellers?.elementos?.length > 0) {
            return;
        }

        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }

    buscarSinFiltro = () => {
        const { numeroPagina, cantidadPagina, razonSocial } = this.INITIAL_REQUEST
        this.props.fetchSellers(razonSocial ?? "", cantidadPagina ?? 0, numeroPagina ?? 0);
        this.props.setFiltroSeller({ ...this.INITIAL_REQUEST, showFilter: this.state.showFilter });
    }

    buscarConFiltro = () => {
        this.props.fetchSellers(
            this.props.filtro?.razonSocial ?? "",
            this.INITIAL_REQUEST.cantidadPagina,
            this.INITIAL_REQUEST.numeroPagina,
        );

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.props.fetchSellers(
            this.props.filtro?.razonSocial ?? "",
            this.INITIAL_REQUEST.cantidadPagina,
            selectedPage
        );
        this.props.setFiltroSeller({ ...this.props.filtro, numeroPagina: selectedPage });

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, sellers: false });
    }

    onEdit = (seller) => {
        this.props.navigate(`/Sellers/Editar/${seller.codigo}`);
    }

    onNew = () => {
        this.props.navigate(`/Sellers/Nuevo`);
    }

    onNewUser = () => {
        this.props.navigate(`/Usuarios/NuevoUser`);
    }

    handleShowFilter = (value) => {
        this.setState({ showFilter: value });
        this.props.setFiltroSeller({ ...this.props.filtro, showFilter: value });
    }

    handleToggleStatus = (seller) => {
        const newStatus = seller.estado === "activo" ? "inactivo" : "activo";
        this.props.changeSellerStatus(seller, newStatus)
            .then(() => {
                // Toast notification is handled in the component? Or here? 
                // The legacy code used toast in the component. 
                // Let's rely on the action updating the state, but we might want to show a toast.
                // For now, let's keep it simple.
            })
            .catch((err) => {
                // Error handling is in the action (reverting state), but maybe show a toast here?
                // console.error(err);
            });
    }


    render() {
        const { isLoadingSellers, userType } = this.props;

        return (
            <div>
                <div className="row align-items-center justify-content-between page-titles">

                    <div className="col-12 col-sm-5">
                        <h3 className="text-themecolor color-rojo-megatone">Sellers</h3>
                    </div>

                    <div className="button-group col-12 col-sm-7 mt-2 mt-sm-0 text-end">

                        <button
                            type="button"
                            className="btn btn-sm btn-green"
                            onClick={() => this.onNew()}
                        >
                            <i className="fa fa-plus-circle" /> Crear Seller Admin
                        </button>

                        {userType.isAdminMod &&
                            <button
                                type="button"
                                className="btn btn-sm btn-green"
                                onClick={() => this.onNewUser()}
                            >
                                <i className="fa fa-plus-circle mx-1" /> Crear Moderador
                            </button>
                        }

                        <BtnToggleFilter
                            show={this.state.showFilter}
                            handleShow={() => this.handleShowFilter(!this.state.showFilter)}
                        />

                    </div>
                </div>

                <div className="col-12" hidden={!this.state.showFilter}>
                    <FiltroSellers
                        getSellers={this.buscarConFiltro}
                        clearFilter={this.buscarSinFiltro}
                    />
                </div>

                {isLoadingSellers ? <BigSpinner /> : (
                    this.props.sellers?.paginateSellers?.elementos?.length > 0 ? (
                        <ul className="list-group">
                            {this.props.sellers.paginateSellers.elementos.map((seller, index) => (
                                <SellerListItem
                                    key={index}
                                    id={seller.codigo}
                                    cuit={seller.cuit}
                                    razonSocial={seller.razonSocial}
                                    codigoPostal={seller.codigoPostal}
                                    telefono={seller.telefono}
                                    estado={seller.estado}
                                    direccion={seller.domicilio}
                                    contactoComercial={seller.email}
                                    emailContacto={seller.emailDespacho}
                                    numeroDomicilio={seller.numeroDomicilio}
                                    localidad={seller.localidad}
                                    provincia={seller.provincia}
                                    onToggleStatus={() => this.handleToggleStatus(seller)}
                                    onEdit={() => this.onEdit(seller)}
                                />
                            ))}
                        </ul>
                    ) :
                        <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                            NO SE ENCONTRARON SELLERS
                        </h5>
                )
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={this.props.sellers.paginateSellers?.cantidadPagina || 0}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={
                            this.props.filtro?.numeroPagina ?
                                this.props.filtro.numeroPagina - 1 : 0
                        }
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    idSeller: state.general.idSeller,
    sellers: state.sellers.sellers,
    filtro: state.sellers.filtro,
    userType: state.general.userType,
    isFilterClear: state.general.limpiar.sellers,
    emptyFilters: state.general.limpiar,
    isLoadingSellers: state.sellers.loadingSellers,
});

export default withNavigation(connect(mapStateToProps, {
    fetchSellers,
    limpiarFiltros,
    setFiltroSeller,
    setTiposPublicacion,
    changeSellerStatus
})(ListSellers));